import axios from './axiosConfig';

export interface AppUser {
    id: number;
    email: string;
}

export const listUsers = async (): Promise<AppUser[]> => {
    const res = await axios.get<AppUser[]>('/api/users');
    return res.data;
};
